<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <h3>Applicants</h3>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="content-header">
                <p>Click on an Applicant ID below to view more details.</p>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="total-header">
                <div class="row">
                  <div class="col-lg-4 col-md-5 col-sm-12 a-h">
                    <!-- Select year of Application -->
                    <mat-label>
                      Application Year
                    </mat-label>
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-select class="mat-select-content" [(ngModel)]="year">
                        <mat-option *ngFor="let year of years" [value]="year.year"
                          (click)="fetchApplicantList(year.year)">
                          {{year.year}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12" a-h>
                                        <!-- Total -->
                      <mat-card class="dashboard-card" id="cd1">
                      <div id="mticon">
                        <mat-icon matListIcon id="mticon">people</mat-icon>
                      </div>
                      <p>Total</p>
                      <mat-card-content>
                        <mat-card-title readonly id="val">{{totalApplicants}}</mat-card-title>
                      </mat-card-content>
                      <div id="arrow">
                        more
                        <mat-icon matListIcon>keyboard_arrow_down</mat-icon>
                      </div>
                    </mat-card>                  
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12 a-h">
                    <!-- Total Degree Applications -->
                    <mat-card class="dashboard-card" id="cd2">
                      <div id="mticon">
                        <mat-icon matListIcon id="mticon">school</mat-icon>
                      </div>
                      <p>Degree</p>
                      <mat-card-content>
                        <mat-card-title readonly id="val">{{totalDegreeApplicants}}</mat-card-title>
                      </mat-card-content>
                      <div id="arrow">
                        more
                        <mat-icon matListIcon>keyboard_arrow_down</mat-icon>
                      </div>
                    </mat-card>
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12 a-h">
                    <!-- Total Diploma Applications -->
                    <mat-card class="dashboard-card" id="cd3">
                      <div id="mticon">
                        <mat-icon matListIcon id="mticon">school</mat-icon>
                      </div>
                      <p>Diploma</p>
                      <mat-card-content>
                        <mat-card-title readonly id="val">{{totalDiplomaApplicants}}</mat-card-title>
                      </mat-card-content>
                      <div id="arrow">
                        more
                        <mat-icon matListIcon>keyboard_arrow_down</mat-icon>
                      </div>
                    </mat-card>
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12 a-h">
                    <!-- Total Certificate Applications -->
                    <mat-card class="dashboard-card" id="cd4">
                      <div id="mticon">
                        <mat-icon matListIcon id="mticon">card_membership</mat-icon>
                      </div>
                      <p>Certificate</p>
                      <mat-card-content>
                        <mat-card-title readonly id="val">{{totalCertificateApplicants}}</mat-card-title>
                      </mat-card-content>
                      <div id="arrow">
                        more
                        <mat-icon matListIcon>keyboard_arrow_down</mat-icon>
                      </div>
                    </mat-card>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 ApplicationTable">
              <mat-card>
                <div id="filtcount">
                  <div class="filtcounttext">
                    <div id="cnt-text" >
                      {{filterCount}}
                    </div>
                  </div>
                  <div id="filtcountinput">
                    <input  matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <table id="table" mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-striped" matSort
                      (matSortChange)="sortData($event)">
                      <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->

                      <!-- Applicant ID Column -->
                      <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                        <td data-label="ID" class="app-id" mat-cell *matCellDef="let element"><a
                            (click)="goToApplicantDetails(element.personId)"> {{element.personId}}</a></td>
                      </ng-container>

                      <!-- Applicant Name -->
                      <ng-container matColumnDef="Applicant">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Applicant </th>
                        <td data-label="Name" mat-cell *matCellDef="let element"> {{element.applicantName}} </td>
                      </ng-container>

                      <!-- Programme Type -->
                      <ng-container matColumnDef="ProgrammeType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Programme </th>
                        <td data-label="Programme" mat-cell *matCellDef="let element"> {{element.programmeType}} </td>
                      </ng-container>
                      <!-- Country -->
                      <ng-container matColumnDef="Country">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Country </th>
                        <td data-label="Country" mat-cell *matCellDef="let element"> {{element.country}} </td>
                      </ng-container>
                      <!-- City -->
                      <ng-container matColumnDef="Hometown">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Hometown </th>
                        <td data-label="Hometown" mat-cell *matCellDef="let element"> {{element.hometown}} </td>
                      </ng-container>
                      <!-- Sex -->
                      <ng-container matColumnDef="Sex">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sex </th>
                        <td data-label="Sex" mat-cell *matCellDef="let element"> {{element.gender}} </td>
                      </ng-container>
                      <!-- Application Received Date -->
                      <ng-container matColumnDef="Date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                        <td data-label="Date" mat-cell *matCellDef="let element"> {{element.applicationReceivedDate}} </td>
                      </ng-container>
                      <!-- Semester application -->
                      <ng-container matColumnDef="Semester">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Semester </th>
                        <td data-label="Semester" mat-cell *matCellDef="let element"> {{element.semester}} </td>
                      </ng-container>
                      <!-- applicantType -->
                      <ng-container matColumnDef="applicantType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ApplicantType </th>
                        <td data-label="Applicant type" mat-cell *matCellDef="let element"> {{element.applicantType}} </td>
                      </ng-container>
                      <!-- Status -->
                      <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                        <td data-label="Status" mat-cell *matCellDef="let element"> {{element.status}} </td>
                      </ng-container>
                      <!-- Status -->
                      <ng-container matColumnDef="Download">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td data-label="Download" mat-cell *matCellDef="let element">
                          <mat-icon aria-hidden="false" aria-label="home icon" fontIcon="save_alt" 
                          (click)="downloadPdf(element.personId)" class="download-icon"
                          ></mat-icon>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #paginator [length]="100" [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                      showFirstLastButtons>
                    </mat-paginator>
                  </div>
                </div>
              </mat-card>
              <button class="floating-button" (click)="downloadExcelFile()">
                <mat-icon>cloud_download</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </mat-sidenav-content>
</mat-sidenav-container>